import {get, post} from '../index'

export default {
  // 获取官网列表
  getWebsiteList (querys) {
    return get('/website/adminOff', querys)
  },
  getWebsiteFormInfo (querys) {
    return get('/website/modularInfo', querys)
  },
  // 修改官网信息
  editWebsiteInfo (querys) {
    return post('/website/modular_update', querys)
  },
  // 添加官网信息
  addWebsiteInfo (querys) {
    return post('/website/adminOff', querys)
  },
  // 删除官网信息
  delWebsiteInfo (querys) {
    return post('/website/modular_del', querys)
  },
  // 上下架官网模块
  updetaWebsite (querys) {
    return post('/website/lower', querys)
  },
  // 获取官网内容列表
  getWebsiteContentList (querys) {
    return get('/website/modular_read', querys)
  },
  // 获取内容详情数据(内容编辑回显)
  getWebsitContentInfo (querys) {
    return get('/website/modularContentInfo', querys)
  },
  // 官网表单管理保存
  postsetFrom (querys) {
    return post('website/setFrom', querys)
  },
  // 官网表单管理获取
  getgetFrom (querys) {
    return get('website/getFrom', querys)
  },
  // 官网数据列表获取
  getformList (querys) {
    return get('website/formList', querys)
  },
  // 官网内容上下架、删除
  updateWebsiteContentInfo (querys) {
    return post('/website/updateJob', querys)
  },
  // 修改官网内容详情的信息（编辑后提交）
  editWebsiteContentInfo (querys) {
    return post('/website/updateContent', querys)
  },
  // 添加官网内容详情信息 （添加提交）
  addWebsiteContentInfo (querys) {
    return post('/website/createContent', querys)
  },
  // 站点绑定数据回显和编辑
  getEditSiteInfo (querys) {
    return post('/card/admin/websitebind', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/website.js